import React, { useEffect, useState } from "react";
import CustomCancelButton from "../../../CommonComponents/CustomCancelButton";
import CustomButton from "../../../CommonComponents/CustomButton";
import { Box } from "@mui/material";
import SubTabs from "./SubTabs";
import MonthlyDialog from "./MonthlyDialog";
import CustomDatePicker from "../../../CommonComponents/CustomDatePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
const currentDate = dayjs();

const tabdata = [
  {
    tab: "Scope 1",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
      {
        title: (
          <>
            CO<sub>2</sub>(tonnes)
          </>
        ),
        dataIndex: "co2",
        editable: true,
        name: "CO2",
      },
      {
        title: (
          <>
            CH<sub>4</sub>(tonnes)
          </>
        ),
        dataIndex: "ch4",
        editable: true,
        name: "CH4",
      },
      {
        title: (
          <>
            N<sub>2</sub>O(tonnes)
          </>
        ),
        dataIndex: "n2o",
        editable: true,
        name: "N2O",
      },
      {
        title: (
          <>
            tCO<sub>2</sub>e
          </>
        ),
        dataIndex: "tco2e",
        editable: true,
        name: "tCO2e",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Stationary Combustion of Fuel",
        unit: "litres",
      },
      {
        key: "2",
        parameter: "Mobile Combustion of Fuel",
        quantity: 2000,
        unit: "litres",
        co2: 2000,
        ch4: 2000,
        n2o: 2000,
        tco2e: 2000,
      },
      {
        key: "3",
        parameter: "Industrial Processes",
        quantity: 2000,
        unit: "litres",
        co2: 2000,
        ch4: 2000,
        n2o: 2000,
        tco2e: 2000,
      },
      {
        key: "4",
        parameter: "Fugitive Emissions",
        quantity: 2000,
        unit: "litres",
        co2: 2000,
        ch4: 2000,
        n2o: 2000,
        tco2e: 2000,
      },
      {
        key: "5",
        parameter: "Land Use",
        quantity: 2000,
        unit: "litres",
        co2: 2000,
        ch4: 2000,
        n2o: 2000,
        tco2e: 2000,
      },
    ],
  },
  {
    tab: "Scope 2",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
      {
        title: (
          <>
            tCO<sub>2</sub>e
          </>
        ),
        dataIndex: "tco2e2",
        editable: true,
        name: "tCO2e",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Purchased Grid Electricity",
        quantity2: 2000,
        unit: "kWh",
      },
      {
        key: "2",
        parameter: "Renewable Sources of Energy",
        quantity2: 2000,
        unit: "kWh",
      },
    ],
  },
  {
    tab: "Scope 3",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
      {
        title: (
          <>
            tCO<sub>2</sub>e
          </>
        ),
        dataIndex: "tco2e3",
        editable: true,
        name: "tCO2e",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Purchased Goods and Services",
        quantity: 2000,
        unit: "kg",
      },
      {
        key: "2",
        parameter: "Capital Goods",
        unit: "kg",
      },
      {
        key: "3",
        parameter:
          "Activities related to Fuel and Energy (not included in Scope 1 and Scope 2 Calculations)",
        quantity: 2000,
        unit: "kWh",
      },
      {
        key: "4",
        parameter: "Upstream Transportation and Distribution",
        quantity: 2000,
        unit: "km",
      },
      {
        key: "5",
        parameter: "Waste Generated in Operations",
        quantity: 2000,
        unit: "tonnes",
      },
      {
        key: "6",
        parameter: "Business Travel",
        quantity: 2000,
        unit: "km",
      },
      {
        key: "7",
        parameter: "Employee Commuting",
        quantity: 2000,
        unit: "km",
      },
      {
        key: "8",
        parameter: "Upstream Leased Assets",
        quantity: 2000,
        unit: "",
      },
      {
        key: "9",
        parameter: "Downstream Transportation & Distribution",
        quantity: 2000,
        unit: "km",
      },
      {
        key: "10",
        parameter: "Processing of Sold Products",
        quantity: 2000,
        unit: "",
      },
      {
        key: "11",
        parameter: "Use of Sold Products",
        quantity: 2000,
        unit: "",
      },
      {
        key: "12",
        parameter: "End-of-Life Treatment of Sold Products",
        quantity: 2000,
        unit: "",
      },
      {
        key: "13",
        parameter: "Downstream Leased Assets",
        quantity: 2000,
        unit: "",
      },
      {
        key: "14",
        parameter: "Franchises",
        quantity: 2000,
        unit: "",
      },
      {
        key: "15",
        parameter: "Investments",
        quantity: 2000,
        unit: "Rs",
      },
    ],
  },
  {
    tab: "Water Consumption",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Consumption",
        unit: "gallons",
      },
    ],
  },
  {
    tab: "Waste Generation",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Recyclable",
        unit: "tonnes",
      },
      {
        key: "2",
        parameter: "Non-Recyclable",
        unit: "tonnes",
      },
    ],
  },
  {
    tab: "Air Pollutants",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        name: "Unit",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: <>CO</>,
        unit: (
          <>
            mg/m<sup>3</sup>
          </>
        ),
      },
      {
        key: "2",
        parameter: (
          <>
            NO<sub>2</sub>
          </>
        ),
        quantity: 2000,
        unit: (
          <>
            µg/m<sup>3</sup>
          </>
        ),
      },
      {
        key: "3",
        parameter: (
          <>
            SO<sub>2</sub>
          </>
        ),
        quantity: 2000,
        unit: (
          <>
            µg/m<sup>3</sup>
          </>
        ),
      },
      {
        key: "4",
        parameter: (
          <>
            O<sub>3</sub>
          </>
        ),
        quantity: 2000,
        unit: (
          <>
            µg/m<sup>3</sup>
          </>
        ),
      },
      {
        key: "5",
        parameter: (
          <>
            PM<sub>2.5</sub>
          </>
        ),
        quantity: 2000,
        unit: (
          <>
            µg/m<sup>3</sup>
          </>
        ),
      },
      {
        key: "6",
        parameter: (
          <>
            PM<sub>10</sub>
          </>
        ),
        quantity: 2000,
        unit: (
          <>
            µg/m<sup>3</sup>
          </>
        ),
      },
    ],
  },
  {
    tab: "Employee Diversity",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of People",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Male",
        quantity: 200,
      },
      {
        key: "2",
        parameter: "Female",
        quantity: 215,
      },
    ],
  },
  {
    tab: "Employee Relations",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of Cases",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Internal Disputes",
        quantity: 20,
      },
      {
        key: "2",
        parameter: "Harassment",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Human Rights Issues",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of Cases",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Pending",
        quantity: 20,
      },
      {
        key: "2",
        parameter: "Resolved",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Community Engagement",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Value",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Number of Beneficiaries",
        quantity: 20,
      },
      {
        key: "2",
        parameter: "Amount Spent on Community Welfare Activities",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Customer Relations",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of Feedbacks",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Positive Feedbacks",
        quantity: 20,
      },
      {
        key: "2",
        parameter: "Negative Feedbacks",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Board Diversity",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of People",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Male",
        quantity: 20,
      },
      {
        key: "2",
        parameter: "Female",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Bribery",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of Cases",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Bribery",
        quantity: 2,
      },
    ],
  },
  {
    tab: "Discrimination",
    columns: [
      {
        title: "Parameter",
        dataIndex: "parameter",
        name: "Parameter",
      },
      {
        title: "Number of Cases",
        dataIndex: "quantity",
        editable: true,
        name: "Quantity",
      },
    ],
    rows: [
      {
        key: "1",
        parameter: "Discrimination",
        quantity: 10,
      },
    ],
  },
];

export default function EsgForm(props) {
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );

  const [tabDataRows, setTabDataRows] = useState([]);

  // useEffect(()=>{

  // },[tabDataRows])

  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [editState, setEditState] = useState(0);
  const handleEditState = (state) => {
    setEditState(state);
  };

  const [rowData, setRowData] = useState([]);
  const handleRowData = (data) => {
    setRowData(data);
  };

  const [colData, setColData] = useState([]);
  const handleColData = (data) => {
    setColData(data);
  };

  const heading = ["Environment", "Social", "Governance"];
  const tabs = [
    [
      "Scope 1",
      "Scope 2",
      "Scope 3",
      "Water Consumption",
      "Waste Generation",
      "Air Pollutants",
    ],
    [
      "Employee Diversity",
      "Employee Relations",
      "Human Rights Issues",
      "Community Engagement",
      "Customer Relations",
    ],
    ["Board Diversity", "Bribery", "Discrimination"],
  ];

  const handleSaveForm = () => {
    return;
  };

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box" }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "8px",
          width: "100%",
          height: "100%",
          marginBottom: "8px",
        }}
      >
        {editState === 0 ? (
          <CustomDatePicker
            name={"data-entry-date"}
            width={200}
            onChange={handleDateChange}
            defaultValue={dayjs(new Date())}
            views={["year", "month"]}
          />
        ) : (
          <CustomDatePicker
            name={"data-entry-date"}
            width={200}
            onChange={handleDateChange}
            disabled={true}
            views={["year", "month"]}
          />
        )}
        <Box sx={{ flexGrow: 1 }}></Box>
        {editState === 0 ? (
          <></>
        ) : (
          <>
            <CustomCancelButton
              onClick={() => setEditState(0)}
              buttonText={"Cancel"}
            ></CustomCancelButton>
            <CustomButton
              onClick={handleSaveForm}
              buttonText={"Save"}
              width={"12px"}
            />
          </>
        )}
      </Box>
      {editState === 0 ? (
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          {heading.map((item, index) => (
            <SubTabs
              key={index + 1}
              cardHeading={item}
              tablist={tabs[index]}
              selectedTab={tabs[index][0]}
              tabdata={tabDataRows}
              editState={handleEditState}
              rowData={handleRowData}
              colData={handleColData}
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          <MonthlyDialog
            rowData={rowData}
            colData={colData}
            date={selectedDate}
          />
        </Box>
      )}
    </Box>
  );
}
